<template>
  <div class="control_bar top">
    <div class="search">
      <input
        type="text"
        class="search_field"
        placeholder="場所名、UUIDから検索"
        @input="beaconFindAction"
      />
    </div>
    <controller
      :dispItems="dispItems"
      :allItems="beacons"
      :router="router"
      @import="importFile"
      @remove="remove"
      @exportFile="exportFile"
    >
    </controller>
    <div class="false_modal_window" v-if="showFalseModal">
      <falseModalWindow :question="falseWord" @close="close">
      </falseModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import controller from '../controller.vue'
import falseModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  props: ['dispItems'],
  data() {
    return {
      inputValue: '',
      showFalseModal: false,
      falseWord: '',
      router: '/beacons/add',
      showloadingModal: false
    }
  },
  computed: {
    beacons() {
      return this.$store.state.beacons.beacons
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    }
  },
  components: {
    controller,
    falseModalWindow,
    loadingModalWindow
  },
  methods: {
    close(e) {
      this.showFalseModal = false
    },
    async remove(e) {
      this.showloadingModal = true
      let deleteList = []
      for (let i = 0; i < e.length; i++) {
        let locationId = e[i].locationId
        deleteList.push({locationId})
      }
      try {
        await this.$store.dispatch('beacons/deleteBeacons', deleteList)
        this.$emit('input-event', this.inputValue)
        this.falseWord = '対象のビーコンを削除しました。'
        this.showFalseModal = true
        // 削除ボタン押下時は詳細画面を初期化する
        this.$router.push('/beacons')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_390003
        let eventType = 3
        let reason = 'MSGCRC0083 '
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRC0083.name +
            this.errorMsg.MSGCRC0083.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    },
    beaconFindAction(event) {
      this.inputValue = event.target.value
      this.$emit('input-event', this.inputValue)
    },
    async importFile(e) {
      this.showloadingModal = true
      var createList = []
      for (let i = 0; i < e.length; i++) {
        let obj = {}
        var csvArrayList = e[i].split(',')
        if (
          csvArrayList.length !==
          this.$store.state.error.importErrorNumber.importBeaconNumber
        ) {
          let eventNumber = this.$store.state.error.errorCode.errorCode_390007
          let eventType = 9
          let reason = 'MSGCRC0008'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.falseWord =
            this.errorMsg.MSGCRC0008.name +
            this.errorMsg.MSGCRC0008.beforeValue +
            (i + 1) +
            this.errorMsg.MSGCRC0008.afterValue +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFalseModal = true
          this.showloadingModal = false
          return
        }
        obj['companyId'] = this.$store.state.masters.loginCompanyId
        obj['locationName'] = csvArrayList[0]
        obj['uuid'] = csvArrayList[1]
        obj['major'] = csvArrayList[2]
        obj['minor'] = csvArrayList[3].replace(/[\r\n]/g, '')
        createList.push(obj)
      }
      this.$router.push('../beacons')
      try {
        await this.$store.dispatch('beacons/importBeacons', createList)
        this.falseWord = 'インポートしました。'
        this.showFalseModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_390009
        let eventType = 3
        let reason = ''
        if (error.response && error.response.data) {
          if (error.response.data.header) {
            let errorMessage = error.response.data.header.message
            if (errorMessage === 'MSGCRC0077') {
              this.falseWord =
                this.errorMsg.MSGCRC0077.name +
                this.errorMsg.MSGCRC0077.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0078') {
              this.falseWord =
                this.errorMsg.MSGCRC0078.name +
                this.errorMsg.MSGCRC0078.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0113') {
              this.falseWord =
                this.errorMsg.MSGCRC0113.name +
                this.errorMsg.MSGCRC0113.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0114') {
              this.falseWord =
                this.errorMsg.MSGCRC0114.name +
                this.errorMsg.MSGCRC0114.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0115') {
              this.falseWord =
                this.errorMsg.MSGCRC0115.name +
                this.errorMsg.MSGCRC0115.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0116') {
              this.falseWord =
                this.errorMsg.MSGCRC0116.name +
                this.errorMsg.MSGCRC0116.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0117') {
              this.falseWord =
                this.errorMsg.MSGCRC0117.name +
                this.errorMsg.MSGCRC0117.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else {
              this.falseWord =
                this.errorMsg.MSGCRC0084.name +
                this.errorMsg.MSGCRC0084.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            }
            reason = errorMessage + ' '
            reason += error.response.status
          } else {
            var obj = error.response.data
            var stringName = Object.keys(obj)[0]
            if (stringName.endsWith('major')) {
              this.falseWord =
                this.errorMsg.MSGCRC0119.name +
                this.errorMsg.MSGCRC0119.value +
                'エラーコード：{' +
                eventNumber +
                '}'
              reason = 'MSGCRC0119'
            } else if (stringName.endsWith('minor')) {
              this.falseWord =
                this.errorMsg.MSGCRC0120.name +
                this.errorMsg.MSGCRC0120.value +
                'エラーコード：{' +
                eventNumber +
                '}'
              reason = 'MSGCRC0120'
            }
          }
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    },
    exportFile(e) {
      this.showloadingModal = true
      try {
        let result = this.$store.state.error.exportTitle.beaconTitle
        for (let i = 0; i < e.length; i++) {
          for (let k of Object.keys(e[i])) {
            if (!e[i][k]) {
              e[i][k] = ''
            }
          }
          result += e[i].locationId + ',' + e[i].locationName + '\r\n'
        }
        if (result === '') {
          let eventNumber = this.$store.state.error.errorCode.errorCode_390008
          let eventType = 9
          let reason = 'MSGCRC0006'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.falseWord =
            this.errorMsg.MSGCRC0006.name +
            this.errorMsg.MSGCRC0006.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFalseModal = true
          this.showloadingModal = false
          return
        }
        let csv = ''
        csv += result
        let link = document.createElement('a')
        let bom = new Uint8Array([0xef, 0xbb, 0xbf])
        let blob
        if (window.navigator.msSaveOrOpenBlob) {
          // for ie
          blob = new Blob([bom, csv], {type: 'text/csv'})
          window.navigator.msSaveOrOpenBlob(blob, 'ビーコン一覧.csv')
        } else if (window.webkitURL && window.webkitURL.createObjectURL) {
          // for chrome (and safari)
          blob = new Blob([bom, csv], {type: 'text/csv'})
          link.setAttribute('download', 'ビーコン一覧.csv')
          link.setAttribute('href', window.webkitURL.createObjectURL(blob))
          link.click()
        } else if (window.URL && window.URL.createObjectURL) {
          // for firefox
          blob = new Blob([bom, csv], {type: 'text/csv'})
          link.setAttribute('download', 'ビーコン一覧.csv')
          link.setAttribute('href', window.URL.createObjectURL(blob))
          link.click()
        } else {
          let eventNumber = this.$store.state.error.errorCode.errorCode_390005
          let eventType = 9
          let reason = 'MSGCRC0007'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.falseWord =
            this.errorMsg.MSGCRC0007.name +
            this.errorMsg.MSGCRC0007.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFalseModal = true
          this.showloadingModal = false
          return
        }
        window.URL.revokeObjectURL(link)
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_390006
        let eventType = 9
        let reason = 'MSGCRC0085'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.falseWord =
          this.errorMsg.MSGCRC0085.name +
          this.errorMsg.MSGCRC0085.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFalseModal = true
        this.showloadingModal = false
        return
      }
      this.showloadingModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/beacons/controlbar.vue